import { render, staticRenderFns } from "./newLogistics.vue?vue&type=template&id=59194b17&"
import script from "./newLogistics.vue?vue&type=script&lang=js&"
export * from "./newLogistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports